import { render, staticRenderFns } from "./codeModal.vue?vue&type=template&id=0b669142&scoped=true"
import script from "./codeModal.vue?vue&type=script&lang=js"
export * from "./codeModal.vue?vue&type=script&lang=js"
import style0 from "./codeModal.vue?vue&type=style&index=0&id=0b669142&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b669142",
  null
  
)

export default component.exports